import {Link, type To} from "react-router";
import {srcUrl} from "@/api/ImageApi.ts";
import type Encounter from "@/encounter/model/Encounter.ts";
import {encounterCardImage} from "@/encounter/encounterCardImage.ts";

export default function EncounterCard({encounter, to}: {encounter: Encounter; to: To}) {
    const image = encounterCardImage(encounter);
    return <Link to={to}
        className="group overflow-hidden rounded-xl border border-border/80 bg-card/90 shadow-lg shadow-black/10 transition-all duration-200 hover:-translate-y-1 hover:border-primary/60 hover:shadow-xl hover:shadow-primary/10 focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-ring/50">
        <div className="relative h-40 overflow-hidden bg-surface">
            {image && <img src={srcUrl(image)} alt="" className="size-full object-cover"/>}
            <div className="pointer-events-none absolute inset-0 bg-linear-to-t from-card/65 to-transparent"/>
        </div>
        <div className="p-4">
            <h2 className="font-semibold group-hover:text-primary">{encounter.name}</h2>
            <p className="mt-1 text-sm text-muted-foreground">{encounter.dungeonName}</p>
        </div>
    </Link>;
}
